export default {
  LIST_FETCHED: 'PARTICIPANTS_FETCHED',
  LIST_LOAD: 'PARTICIPANTS_LOAD',
  ITEM_DETAIL: 'PARTICIPANTS_DETAIL',
  BUTTON_LOAD: 'PARTICIPANTS_BUTTON_LOAD',
};
